// extracted by mini-css-extract-plugin
module.exports = {"iconBtn":"index_iconBtn__OTxmv","dark":"index_dark__5ttD6"};